import http from '../../src/api/axiosConfig'

class ManageMobileClients {

    loadClients() {
        return http.get('/v1/mobile/client/all')
    }

    blockTransactions(data) {
        return http.post('/v1/web/client/block-transactions', data)
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new ManageMobileClients()
